import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enNs1 from './locales/en/ns1.json';
import uaNs1 from './locales/ua/ns1.json';
import ruNs1 from './locales/ru/ns1.json';

export const defaultNS = 'ns1';

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  fallbackLng: 'en',
  defaultNS,
  resources: {
    en: {
      ns1: enNs1
    },
    ua: {
      ns1: uaNs1
    },
    ru: {
      ns1: ruNs1
    },
  },
});

export default i18n;